<Nav {active}/>

<main>
    <svelte:component this={route}/>
</main>

<script>

    import { onMount } from 'svelte'
    import Nav from "./nav.svelte"
    import Navaid from 'navaid';
    import { onDestroy } from 'svelte';
    import { setContext } from 'svelte';

    // TODO: Switch to prod.api.keyosh.com for production
    window.apiUrl = (isProduction) ? 'https://prod.api.keyosh.com' : 'http://localhost:8010/proxy';
    window.dashUrl = (isProduction) ? 'https://dashboard.keyosh.com' : 'https://dev.dashboard.keyosh.com';

    let route, params={}, active;
    let uri = location.pathname;
    $: active = uri.split('/')[1] || 'dashboard';


    function run(thunk, obj) {

        const target = uri;

        thunk.then(m => {

            if (target !== uri) {

                return;
            }

            params = obj || {};

            if (m.preload) {

                m.preload({ params }).then(() => {

                    if (target !== uri) {

                        return;
                    }

                    route = m.default;
                    window.scrollTo(0, 0);

                });

            } else {

                route = m.default;
                window.scrollTo(0, 0);

            }

        });

    }

    function track(obj) {

        uri = obj.state || obj.uri || location.pathname;
    }

    addEventListener('replacestate', track);
    addEventListener('pushstate', track);
    addEventListener('popstate', track);

    const router = Navaid('/')
        .on('/', () => run(import('../routes/home.svelte')))
        .on('/login', () => run(import('../routes/login.svelte')))
        .on('/register', () => run(import('../routes/onboarding/register.svelte')))
        .on('/reset', () => run(import('../routes/reset.svelte')))
        .on('/plans', () => run(import('../routes/onboarding/plans.svelte')))
        .on('/payment', () => run(import('../routes/onboarding/payment.svelte')))
        .on('/locations', () => run(import('../routes/onboarding/locations.svelte')))
        .on('/integrations', () => run(import('../routes/onboarding/integrations.svelte')))
        .on('/collecting', () => run(import('../routes/onboarding/collecting.svelte')))
        .on('/settings/locations', () => run(import('../routes/settings/locations.svelte')))
        .on('/settings/billing', () => run(import('../routes/settings/billing.svelte')))
        .on('/settings/profile', () => run(import('../routes/settings/profile.svelte')))
        .on('/reviews', () => run(import('../routes/reviews.svelte')))
        .on('/keywords', () => run(import('../routes/keywords.svelte')))
        .on('/guests', () => run(import('../routes/guests.svelte')))
        .on('/table', () => run(import('../routes/table.svelte')))
        .listen();

    setContext('router', router);

    onDestroy(router.unlisten);

</script>

